import BigNumber from 'bignumber.js';
import { ethers } from 'ethers';
import { getContractAddress } from 'utilities';
import config from 'config';
import dlVaultAbi from 'constants/contracts/abis/dlVault.json';

import { BscChainId } from 'types';

export interface RepayUmiInput {
  userSigner: ethers.Signer;
  amountWei: BigNumber;
  chainId?: BscChainId;
}

export interface RepayUmiOutput {
  success: boolean;
  txHash?: string;
  error?: string;
}

const repayUmi = async ({
  userSigner,
  amountWei,
  chainId = config.chainId,
}: RepayUmiInput): Promise<RepayUmiOutput> => {
  try {
    const userAddress = await userSigner.getAddress();
    const dlVault = new ethers.Contract(
      getContractAddress('dlVault'),
      dlVaultAbi,
      userSigner,
    );

    const tx = await dlVault.claimAndWithdraw(amountWei.toFixed(0), { from: userAddress });
    await tx.wait();

    return {
      success: true,
      txHash: tx.hash,
    };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error',
    };
  }
};

export default repayUmi;
